// Admin role detection — probes GET /api/admin/status after auth ready.
// Ported from client/client/src/state/useAdminStatus.ts.

// Admin role detection — probes Keycast GET /api/admin/status after auth ready.
// Uses keycastClient.adminStatus() (Keycast origin), NOT serverFetch (Synvya server).

import { create } from 'zustand'
import { adminStatus } from '@/lib/keycastClient'

export type AdminRole = 'full' | 'support' | null

interface AdminStatusState {
  role: AdminRole
  loaded: boolean
  refresh: () => Promise<void>
  reset: () => void
}

export const useAdminStatus = create<AdminStatusState>((set) => ({
  role: null,
  loaded: false,

  refresh: async () => {
    try {
      const res = await adminStatus()
      const role: AdminRole =
        res.role === 'full' ? 'full' :
        res.role === 'support' ? 'support' :
        res.is_admin ? 'full' : null
      set({ role, loaded: true })
    } catch {
      // Any failure (401, 403, network) → not admin
      set({ role: null, loaded: true })
    }
  },

  reset: () => set({ role: null, loaded: false }),
}))
